import '../css/app.scss'
import './plugins/chartjs-setup.js'

import vuetify from './plugins/vuetify'
import { createApp } from 'vue'
import Lernleitstand from './Lernleitstand.vue'

import router from './router'
import store from './store'

import axios from 'axios'
import VueAxios from 'vue-axios'
import { createPinia } from 'pinia'

import Storage from 'vue-web-storage'

import mdiVue from 'mdi-vue/v3'
import * as mdijs from '@mdi/js'

const pinia = createPinia()
const app = createApp(Lernleitstand)

app.use(store)
    .use(VueAxios, axios)
    .use(Storage)
    .use(mdiVue, { icons: mdijs })
    .use(router)
    .use(pinia)
    .use(vuetify)

app.provide('axios', app.config.globalProperties.axios) // provide 'axios'
app.provide('store', app.config.globalProperties.store) // provide 'store'

app.mount('#lernleitstand-app')
